import { Stack, Typography } from '@mui/material'
import truncate from 'lodash/truncate'

import { Maybe } from '@/clients/utoniq-core/schema'
import { StorageImage } from '@/core'

export type CryptoCurrency = 'polygon'

/**
 * @description
 * 仮想通貨残高表示
 */
export const CryptoWalletBalance = ({
  cryptoWalletBalance,
  size = 'large',
  cryptoCurrency = 'polygon',
}: {
  cryptoWalletBalance?: Maybe<string>
  size?: 'large'
  cryptoCurrency?: CryptoCurrency
}) => {
  const iconSize = {
    large: {
      width: 40,
      height: 40,
    },
  }

  const TypographySxProps = {
    large: {
      fontSize: 32,
      width: 120,
      ml: 2,
    },
  }

  return (
    <Stack flexDirection="row" justifyContent="center" alignItems="center">
      <StorageImage
        target="common"
        src={`images/nft/${cryptoCurrency}.png`}
        {...iconSize[size]}
      />
      <Typography
        color="text.secondary"
        align="center"
        sx={{
          fontFamily: 'Oswald',
          fontWeight: 'normal',
          verticalAlign: 'center',
          ...TypographySxProps[size],
        }}
      >
        {cryptoWalletBalance &&
          truncate(cryptoWalletBalance, { length: 8, omission: '' })}
      </Typography>
    </Stack>
  )
}
